module.exports = __webpack_public_path__ + "images/emoji/violin.9a9dfe21b56399fe9f08.png";